import { Outlet } from 'react-router-dom'


const Club = () => {
   
  return (
    <>
   <div><Outlet /></div>
    </>
  )
}

export default Club